<template>
  <div class="wf-file-row">
    <div class="file-status">
      <button class="button is-small is-static is-hollow is-borderless">
        <span class="icon">
          <i
            v-if="isProcessing"
            class="fa-solid fa-spinner fa-spin has-text-gray"
          />
          <i v-else-if="isValid" class="fa-solid fa-check has-text-success" />
          <i v-else-if="isInvalid" class="fa-solid fa-times has-text-danger" />
          <i v-else-if="isDeleted" class="fa-solid fa-trash" />
        </span>
      </button>
    </div>
    <div class="file-info">
      <slot name="file-name" :is-processing="isProcessing">
        <p class="file-info-name">{{ filePath || name }}</p>
        <p class="help">
          <span v-if="createdBy">
            Added by
            <router-link :to="createdByRouterLink">
              {{ createdBy }}
            </router-link>
            ,
          </span>
          <span v-if="showModified">
            , modified by
            <router-link :to="modifiedByRouterLink">
              {{ modifiedBy }}
            </router-link>
            {{ modifiedStr }}
          </span>
          <span v-else-if="createdStr">{{ createdStr }}</span>
        </p>
      </slot>
    </div>
    <template v-if="!isDeleted">
      <div class="file-type">
        <slot
          name="file-type"
          :is-processing="isProcessing"
          :is-changing-type="isChangingType"
        >
          {{ $filters.capitalize(dataType.value) }}
        </slot>
      </div>
      <div class="file-controls">
        <slot
          name="controls"
          :is-restorable="isRestorable"
          :is-processing="isProcessing"
          :is-changing-type="isChangingType"
        ></slot>
      </div>
    </template>
    <template v-else>has been deleted</template>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { momentDate } from '@/utils'

export default {
  name: 'WorkflowFileRow',
  props: {
    workflowFile: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const file = ref(props.workflowFile)
    const id = computed(() => file.value.id)
    const name = computed(() => file.value.name)
    const filePath = computed(() => file.value.file_path)
    const dataType = computed(() => file.value.data_type)
    const createdBy = computed(() => file.value?.created_by?.username)
    const dateCreated = computed(
      () => file.value?.created && momentDate(file.value.created),
    )
    const createdStr = computed(
      () => dateCreated.value && momentDate(dateCreated.value).fromNow(),
    )
    const createdByRouterLink = computed(() => ({
      name: 'userDetail',
      params: { userUsername: createdBy.value },
    }))
    const modifiedBy = computed(() => file.value?.modified_by?.username)
    const dateModified = computed(
      () => file.value?.created?.value && momentDate(file.value.created),
    )
    const modifiedStr = computed(
      () => dateModified.value && momentDate(dateModified.value).fromNow(),
    )
    const modifiedByRouterLink = computed(() => ({
      name: 'userDetail',
      params: { userUsername: modifiedBy.value },
    }))
    const showModified = computed(
      () =>
        dateCreated.value &&
        dateModified.value &&
        dateCreated.value.diff(dateModified.value, 'seconds') > 10,
    )
    const isRestorable = computed(() => file.value?.is_restorable === true)
    const isDeleted = computed(() => file.value?.is_deleted)
    const isDeleting = computed(() => file.value?.isDeleting)
    const isValid = computed(() => file.value?.isValid || true)
    const isInvalid = computed(() => file.value?.isInvalid || false)
    const isRestoring = computed(() => file.value?.isRestoring)
    const isChangingType = computed(() => file.value?.isChangingType)

    const isProcessing = computed(
      () => isDeleting.value || isRestoring.value || isChangingType.value,
    )

    return {
      file,
      id,
      name,
      filePath,
      dataType,
      isDeleted,
      isRestorable,
      // handleChangeType,
      // handleDelete,
      isProcessing,
      isDeleting,
      isValid,
      isInvalid,
      isRestoring,
      isChangingType,
      createdBy,
      createdStr,
      createdByRouterLink,
      modifiedBy,
      modifiedStr,
      modifiedByRouterLink,
      showModified,
    }
  },
}
</script>

<style lang="scss" scoped>
.wf-file-row {
  display: contents;

  .file-info .help:empty {
    display: none;
  }
  .file-info-name {
    word-break: break-all;
    word-wrap: break-word;
  }

  [class^='file-'],
  [class*=' file-'] {
    &:empty {
      display: none;
    }
  }
}
</style>
